import useAppContext from '@/hooks/useAppContext'
import useModal from '@/hooks/useModal'
import ModalCustom from '@/scenes/Editor/components/Modal/Modal'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

function ModalNoInternet() {
  const { isLoadedJsonSuccess, setIsLoadedJsonSuccess } = useAppContext()
  const { showModalType, setShowModalType } = useModal()
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <ModalCustom
      isOpen={showModalType === ShowModalType.NO_INTERNET}
      onClose={() => {}}
      content={{
        header: t('Looks like there’s no internet'),
        desc: t(`Connect to the internet to ${location.pathname.includes('projects') || !isLoadedJsonSuccess ? 'open' : 'save'} this project.`),
      }}
      action={{
        primary: {
          name: t('Ok'),
          handle: () => {
            setShowModalType(null)
            if(!isLoadedJsonSuccess) {
              setIsLoadedJsonSuccess(true)
            }
          }
        },
      }}
    ></ModalCustom>
  )
}

export default ModalNoInternet